import { Component } from '@angular/core';
import { CreateContactModalComponent } from './create-modal.component';
import {
  FieldOptionsInjectionToken as ModelDrivenFormFieldOptionsInjectionToken,
  modelDrivenFormFieldOptionsInjectionTokenGenerator,
  ObjectType,
  PageAnalyticsInjectionToken,
  pageAnalyticsInjectionTokenGenerator,
} from '../../tokens-and-interfaces';
import { ContactTableCustomizationService, TableCustomizationService } from '../../shared-services';

@Component({
  // requires selector to prevent ID collision
  selector: 'crm-create-modal',
  template: ` <crm-contact-modal [objectType]="objectType"></crm-contact-modal> `,
  imports: [CreateContactModalComponent],
  standalone: true,
  providers: [
    {
      provide: ModelDrivenFormFieldOptionsInjectionToken,
      useFactory: modelDrivenFormFieldOptionsInjectionTokenGenerator('Contact'),
    },
    {
      provide: PageAnalyticsInjectionToken,
      useFactory: pageAnalyticsInjectionTokenGenerator('Contact'),
    },
    { provide: TableCustomizationService, useClass: ContactTableCustomizationService },
  ],
})
export class CrmCreateModalContactComponent {
  objectType: ObjectType = 'Contact';
}
